<template>
  <b-row class="align-items-end my-3">
    <b-col>
      <label class="m-0">{{ $t("catalogs.Tantièmes_détenus") }}</label>
      <ValidationProvider
        :ref="`level-step3-${votingRight.id}`"
        v-slot="{ errors, classes }"
        :name="'tantièmes détenus'"
        :rules="{ min_value: 0 }"
      >
        <b-input
          type="number"
          :value="parts"
          :min="0"
          @focusout="
            updateVotingRight(
              'parts',
              $event.target.valueAsNumber ? $event.target.valueAsNumber : null
            )
          "
        />
        <span :class="classes">{{ errors[0] }}</span>
      </ValidationProvider>
    </b-col>
    <b-col class="text-right">
      <b-alert variant="primary" class="m-0" show>
        {{ votingCategoryName }}
        <font-awesome-icon
          class="ml-2"
          style="cursor: pointer;"
          icon="trash-alt"
          @click="DELETE_VOTING_RIGHT"
        />
      </b-alert>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    votingRight: {
      type: Object,
      default: () => {
        return {};
      },
    },
    votingCategories: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      parts: 0,
    };
  },
  computed: {
    votingCategoryName() {
      var votingCategory = this.$_.findWhere(this.votingCategories, {
        id: this.votingRight.voting_category_id,
      });
      if (votingCategory) {
        return votingCategory.name;
      } else {
        return "";
      }
    },
  },
  created() {
    if (this.votingRight.parts == null) {
      this.parts = 0;
    } else {
      this.parts = this.votingRight.parts;
    }
  },
  mounted() {
    this.$refs["level-step3-" + this.votingRight.id].validate();
  },
  methods: {
    updateVotingRight(key, value) {
      this.parts = value;
      this.$refs["level-step3-" + this.votingRight.id].validate().then(res => {
        console.log(res);
        console.log(res.valid);
      });
      this.$emit("updateVotingRight", this.votingRight, key, value);
    },
    DELETE_VOTING_RIGHT() {
      var self = this;
      self
        .$swal(self.alertQuestion())
        .then(res => {
          if (res.value) {
            this.$emit("deleteVotingRight", this.votingRight);
          } else {
            // Cancel
          }
        })
        .catch(err => {
          self.$swal(self.alertError());
        });
    },
  },
};
</script>
<style scoped>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
